import firebase from '../firebase';
import 'firebase/firestore';
import 'firebase/auth';

const auth = firebase.auth();

const firestore = firebase.firestore();

//firebase.auth().signOut();

function LogIn() {

    const signInWithGoogle = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        auth.signInWithPopup(provider).then((result) => {
            firestore.collection('users').doc(auth.currentUser!.uid).set({
                active: true,
                cards: [],
                admin: true,
            });
        })
        //here is where we really need to create firebase document of CID

    }

    return (
        <div>
            <button onClick={signInWithGoogle}>Sign In With Google</button>
        </div>
    )
}

export default LogIn;